import { createSlice } from '@reduxjs/toolkit';

import { timeInMs } from '../../../../shared';
import cachedFetch from '../../../../shared/cachedFetch';
import { GlobalState, Thunk } from '../../../types.global';
import { LastSeenCounter, TotalCounterState } from './types';
import { browserStorageUpdate } from '../../../store/actions';

export const getInitialTotalCounterState = ({ totalCounter }: GlobalState): TotalCounterState => ({
  lastSeen: totalCounter?.lastSeen,
});

// -----------------------------------------------------------------------------
// SLICE

export const totalCounterSlice = createSlice({
  name: 'totalCounter',
  initialState: null,
  reducers: {
    fetchTotalCounterFulfilled: (state, { payload }) => {
      if (!state.lastSeen || state.lastSeen.total < payload.total) {
        state.lastSeen = payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(browserStorageUpdate, (state, { payload }) => {
      if (payload.isNewer) {
        return getInitialTotalCounterState(payload.state);
      }
    });
  }
});

const { fetchTotalCounterFulfilled } = totalCounterSlice.actions;

interface TotalCounterResponse {
  counter: number,
  counterLastWeek: number,
  fetchedAt: number,
}

export const fetchTotalCounter = (): Thunk => async (dispatch) => {
  const res = await cachedFetch<TotalCounterResponse>(
    `${process.env.APP_URL}/api/counter`,
    timeInMs.day
  );
  const { counter, counterLastWeek, fetchedAt } = res;
  dispatch(
    fetchTotalCounterFulfilled({
      total: counter,
      lastWeek: counterLastWeek,
      fetchedAt,
    })
  );
};

// -----------------------------------------------------------------------------
// Selectors

export const selectTotalCounter = (state: GlobalState): LastSeenCounter =>
  state.totalCounter.lastSeen;

// -----------------------------------------------------------------------------

export default totalCounterSlice.reducer;
